import { http, HttpResponse } from 'msw'

import { allManagers } from 'app/mocks/data/park/managers'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersManagerApi } from 'app/utils/park/manager'

import type { ManagersRequest } from 'app/types/park/manager'

export const getAllManagers = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.managers.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const nameFilter = searchParams.get(searchParametersManagerApi.NAME)

        const hasOrderFilter = searchParams.get(
            searchParametersManagerApi.HAS_ORDER,
        )

        let allManagersFiltered = allManagers

        // Name filter
        if (nameFilter) {
            allManagersFiltered = allManagersFiltered.filter((manager) =>
                manager.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Has order filter
        if (hasOrderFilter) {
            allManagersFiltered = allManagersFiltered.filter(
                (manager) => manager.has_order.toString() === hasOrderFilter,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allManagersFiltered.length > limit
                ? offset + limit
                : allManagersFiltered.length

        const results = allManagersFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allManagersFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ManagersRequest>({
            next,
            results,
        })
    },
)
